<layer-header
  (closeLayer)="cancel()"
  [listIcons]="false"
  [title]="documentResult.id ? 'Edit Result' : 'Add Result'">
  <ng-content></ng-content>
</layer-header>

<div class="row" style="margin:0;">
  <div class="col-12">
    <form name="itemForm" class="form-validation">
      <div class="form-group">
        <div class="row">
          <div *ngIf="documentResult" class="col-12">
            <label class="input-label field-required">{{
              'annexes.docs.name' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="name"
              [(ngModel)]="documentResult.name"
              placeholder="{{ 'annexes.doc.name_placeholder' | translate }}"
              #name="ngModel"
              [rangeLength]="[2, 256]"
              required
              autofocus
            />
          </div>
        </div>
        <p class="error" *ngIf="name && name.errors?.required && (name?.dirty && name?.touched)">
          {{ 'form.validate.required' | translate }}
        </p>
        <p class="error" *ngIf="name && name.errors?.rangeLength && (name?.dirty && name?.touched)">
          {{ 'form.validate.minLenght' | translate }} 2!
        </p>
        <p class="error" *ngIf="name && name.errors?.rangeLength && (name?.dirty && name?.touched)">
          {{ 'form.validate.maxLenght' | translate }} 256!
        </p>
      </div>
      <div class="row">
        <div class="col mb-3">
          <primary-text-button
            [noLeftPadding]="true"
            (onClick)="save()"
            [disabled]="isLoading || !!(name && name.invalid)"
          >
            {{ 'Save' | translate }}
          </primary-text-button>
          <cancelary-text-button (click)="cancel()" type="button">
            {{ 'Cancel' | translate }}
          </cancelary-text-button>
          <confirmation
            [buttonName]="'general.delete'"
            [question]="'confirm.areyousure'"
            (isConfirmed)="deleteDocumentResult($event)"
            *ngIf="documentResult?.id != undefined"
          ></confirmation>
        </div>
      </div>
    </form>
  </div>
</div>

